// Backend URL resolution.
// Priority: runtime config (/runtime-env.js, generated at container start on Railway)
// → build-time REACT_APP_BACKEND_URL → same origin.
export const BACKEND_URL =
    (window.__RUNTIME_ENV__ && window.__RUNTIME_ENV__.BACKEND_URL) ||
    process.env.REACT_APP_BACKEND_URL ||
    "";
